import React from 'react'
import styled from 'styled-components'
import { useI18n } from '../../../i18n/I18nContext'

const StyledEmailInput = styled.input`
  padding: 12px 20px;
  width: 100%;
  max-width: 360px;
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', Roboto, Arial, sans-serif;
  
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  color: #000;
  
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  
  outline: none;
  transition: all 0.2s ease-in-out;
  
  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
  }
  
  &:focus {
    background: rgba(255, 255, 255, 0.25);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 255, 255, 0.6);
  }
  
  @media (max-width: 1024px) {
    padding: 8px 16px;
    max-width: 50vw;
    font-size: 0.7rem;
  }
`

const EmailInput: React.FC = () => {
  const { t } = useI18n()
  return <StyledEmailInput placeholder={t('newsletter.emailPlaceholder')} />
}

export default EmailInput
